import {
  EGE_YEAR_OPTIONS,
  FINANCE_OPTIONS,
  GOAL_OPTIONS,
  PARENT_ATTENTION_HINT,
  PARENT_FINANCE_HINT,
  PARENT_GOAL_HINT,
  SCORE_OPTIONS,
  needsEgeDetails,
} from '../questionnaire/parentOptions';

function RadioGroup({ name, options, value, onChange, required }) {
  return (
    <div className="questionnaire-options" role="radiogroup">
      {options.map((opt) => (
        <label key={opt.value} className="questionnaire-option">
          <input
            type="radio"
            name={name}
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            required={required}
          />
          <span>{opt.label}</span>
        </label>
      ))}
    </div>
  );
}

export default function ParentQuestionnaireForm({
  form,
  onChange,
  onSubmit,
  saving,
  error,
  success,
  studentName,
  submitLabel = 'Сохранить анкету',
  extraActions = null,
}) {
  const showEge = needsEgeDetails(form.goal);

  function setField(field, value) {
    onChange({ ...form, [field]: value });
  }

  return (
    <form className="questionnaire-form" onSubmit={onSubmit}>
      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {studentName && (
        <p className="text-secondary" style={{ marginBottom: '1rem' }}>
          Анкета по ученику: <strong>{studentName}</strong>
        </p>
      )}

      <fieldset className="questionnaire-block">
        <legend>1. Цель подготовки</legend>
        <p className="questionnaire-hint">{PARENT_GOAL_HINT}</p>
        <RadioGroup
          name="goal"
          options={GOAL_OPTIONS}
          value={form.goal}
          onChange={(v) => setField('goal', v)}
          required
        />
        {form.goal === 'other' && (
          <div className="form-group" style={{ marginTop: '0.75rem' }}>
            <label htmlFor="parent-goal-other">Свой вариант</label>
            <input
              id="parent-goal-other"
              type="text"
              className="form-input"
              value={form.goal_other}
              onChange={(e) => setField('goal_other', e.target.value)}
              required
            />
          </div>
        )}
      </fieldset>

      {showEge && (
        <>
          <fieldset className="questionnaire-block">
            <legend>1.2. В каком году сдавать ЕГЭ</legend>
            <RadioGroup
              name="ege_year"
              options={EGE_YEAR_OPTIONS}
              value={form.ege_year}
              onChange={(v) => setField('ege_year', v)}
              required
            />
            {form.ege_year === 'other' && (
              <div className="form-group" style={{ marginTop: '0.75rem' }}>
                <label htmlFor="parent-ege-year-other">Укажите год</label>
                <input
                  id="parent-ege-year-other"
                  type="text"
                  className="form-input"
                  value={form.ege_year_other}
                  onChange={(e) => setField('ege_year_other', e.target.value)}
                  required
                />
              </div>
            )}
          </fieldset>

          <fieldset className="questionnaire-block">
            <legend>1.3. Сколько нужно баллов</legend>
            <p className="questionnaire-hint">
              От этого зависит объём домашней работы и количество раз в неделю. Можно поменять позднее.
            </p>
            <RadioGroup
              name="target_score"
              options={SCORE_OPTIONS}
              value={form.target_score}
              onChange={(v) => setField('target_score', v)}
              required
            />
          </fieldset>
        </>
      )}

      <fieldset className="questionnaire-block">
        <legend>2. Финансовые возможности</legend>
        <p className="questionnaire-hint">{PARENT_FINANCE_HINT}</p>
        <RadioGroup
          name="finance"
          options={FINANCE_OPTIONS}
          value={form.finance}
          onChange={(v) => setField('finance', v)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>3. На что обратить внимание</legend>
        <p className="questionnaire-hint">{PARENT_ATTENTION_HINT}</p>
        <textarea
          className="form-textarea"
          rows={5}
          value={form.attention_notes}
          onChange={(e) => setField('attention_notes', e.target.value)}
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>4. Телефон</legend>
        <input
          type="tel"
          className="form-input"
          value={form.phone}
          onChange={(e) => setField('phone', e.target.value)}
          placeholder="+7…"
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>5. ВК или Макс для связи</legend>
        <p className="questionnaire-hint">Вставьте ссылку vk.com/… или max.ru/…</p>
        <input
          type="url"
          className="form-input"
          value={form.messenger_url}
          onChange={(e) => setField('messenger_url', e.target.value)}
          placeholder="https://vk.com/… или https://max.ru/…"
          required
        />
      </fieldset>

      <fieldset className="questionnaire-block">
        <legend>6. Комментарий</legend>
        <p className="questionnaire-hint">Если осталось что сказать — сюда.</p>
        <textarea
          className="form-textarea"
          rows={3}
          value={form.comment}
          onChange={(e) => setField('comment', e.target.value)}
        />
      </fieldset>

      <div className="questionnaire-actions">
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? 'Сохранение...' : submitLabel}
        </button>
        {extraActions}
      </div>
    </form>
  );
}
